import PageShell from "./PageShell";
import PageHero from "./PageHero";
import Gallery from "./Gallery";
import EventsSection from "./EventsSection";
import RelatedPages from "./RelatedPages";
import { ORIG } from "../mock";

export default function GalleryPage() {
  return (
    <PageShell>
      <PageHero
        eyebrow="GDGSS at Glance"
        title="Stories from"
        italic="our 20-acre campus."
        image={`${ORIG}/bg_1-min.jpg`}
        blurb="Moments of joy, learning, sport, art and community life at GD Goenka Signature School."
      />
      <Gallery />
      <EventsSection />
      <RelatedPages current="/gallery.html" />
    </PageShell>
  );
}
